import { Box, Group, Text, useMantineTheme } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { LuEye } from "react-icons/lu";

function PreviewBanner() {
  const { t } = useTranslation("common");
  const theme = useMantineTheme();

  return (
    <Box
      pos="fixed"
      bottom={0}
      left={0}
      right={0}
      // 🔒 EXCEPTION: Shadow token and z-index
      style={{
        zIndex: 1000,
        boxShadow: "var(--mantine-shadow-md)",
      }}
      bg="orange.6"
      c={theme.other.semanticColors.invertedText}
      py="xs"
      px="md"
    >
      <Group justify="center" gap="xs">
        <LuEye size={18} />
        <Text fz="md" fw={600}>
          {t("previewMode.title", { ns: "common" })}
        </Text>
        <Text fz="xs" display={{ base: "none", md: "block" }}>
          {t("previewMode.description", { ns: "common" })}
        </Text>
      </Group>
    </Box>
  );
}

export default PreviewBanner;
